module.exports = __webpack_public_path__ + "img/fog.44096d7e.svg";